import Bullbozer from "../../assests/images/partners/Bullbozer.png";
import System5s from "../../assests/images/partners/system.png"; ;
const Ansell = "https://www.ansell.com/-/media/projects/ansell/website/ansell_logo.ashx?rev=d2afbc1248594e258bc1f69853e7e149&la=en&h=42&w=136&mw=143&hash=3DA788F1D49D9FD32A2C7150BD908787"
const Bullard = "https://www.bullard.com/wp-content/themes/bullard/library/images/site-logo.png";
const Chiba = "https://www.chiba.de/wp-content/uploads/2019/12/chiba-gloves-logo-1572423624.jpg";
const Harvik = "https://www.harvik.com/wp-content/uploads/2021/09/logo-harvik.jpg"
const MSA = "https://www.msasafety.com/images/MSA-Logo-2.png";
const Talan = "https://talansafetyshoes.com/wp-content/themes/talan/images/logo_1.svg";
const threeM="https://www.3mae.ae/3m_theme_assets/themes/3MTheme/assets/images/unicorn/Logo.svg";
const Victor = "https://esab.com/sites/nam_en/assets/victor%EF%B9%96v=201910220916-1620329385.svg?cacheid=0.8750835057365276";
const Venus= "https://venusohs.com/wp-content/uploads/2023/12/cropped-VENUS-LOGO-New-1.jpg";
const ironclad = "https://cdn11.bigcommerce.com/s-6kqqhi4p7y/images/stencil/250x50/ic_logo_1633721801__42356.original.png"

export const partnerLineOne = [
    {
        name:"3M",
        logo:threeM,
    },
    {
        name:"Bullbozer",
        logo:Bullbozer,
    },
    {
        name:"Ansell",
        logo:Ansell,
    },
    {
        name:"Bullard",
        logo:Bullard,
    },
    {
        name:"Chiba",
        logo:Chiba,
    },
    {
        name:"Harvik",
        logo:Harvik,
    },
    {
        name:"Ironclad",
        logo:ironclad,
    },
    {
        name:"MSA",
        logo:MSA,
    },
    {
        name:"System5s",
        logo:System5s,
    },
    {
        name:"Talan",
        logo:Talan,
    },
    {
        name:"Venus",
        logo:Venus,
    },
    {
        name:"Victor",
        logo:Victor,
    },
]
